import { AccessToken, OpenAPI } from '@beeboard/common';
import axios from 'axios';

// init axios interceptors
import './axiosInterceptors';

export class AuthService {
  /**
   * @name login
   * authenticates a user and resolves an access token
   *
   * @param {String} username
   * @param {String} password
   * @returns {AccessToken}
   */
  public static async login(username: string, password: string) {
    try {
      const queryStr = `username=${encodeURIComponent(
        username,
      )}&password=${encodeURIComponent(password)}&grant_type=password`;

      const { data } = await axios.post<AccessToken>('/v1/login', queryStr, {
        baseURL: OpenAPI.BASE,
      });

      return data;
    } catch (failure) {
      return Promise.reject(failure);
    }
  }

  /**
   * @name refresh
   * @description
   * Returns a fresh bearer and refresh token by providing the current refresh token
   *
   * @requires http
   * @param {String} refresh_token
   * @returns {Promise<models.AccessToken>}
   */
  public static async refresh(refresh_token: string) {
    try {
      const queryString = `refresh_token=${encodeURIComponent(
        refresh_token,
      )}&grant_type=refresh_token`;

      const { data } = await axios.post<AccessToken>(
        '/v1/refresh',
        queryString,
        {
          baseURL: OpenAPI.BASE,
        },
      );

      return data;
    } catch (failure) {
      return Promise.reject(failure);
    }
  }

  /**
   * @name logout
   * @description
   * Invalidates a current login
   *
   * @requires http
   * @param {String} refresh_token
   * @returns
   */
  public static async logout(refresh_token: string, access_token: string) {
    try {
      const response = await axios.post<void>(
        '/v1/logout',
        {
          refresh_token,
        },
        {
          baseURL: OpenAPI.BASE,
          headers: {
            Authorization: 'Bearer ' + access_token,
          },
        },
      );

      return response;
    } catch (failure) {
      return Promise.reject(failure);
    }
  }
}
